import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import AppRoutes from '@ui/containers/layout/AppRoutes';
import Loading from '@ui/components/VnLoader';
import '@ui/styles/bootstrap.css';
import '@ui/styles/style.css';
import '@ui/styles/toggle-button-style.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import i18n from './i18n';
import moment from 'moment';
import { logout } from '@application/features/auth/authSlice';
import { useLocation } from 'react-router-dom';
import { resetStateByPathName } from '@application/common/helpers/state-helper';
import { Container } from 'react-bootstrap';
import { selectIsLoading } from '@application/features/common/loadingSlice';
import LocalStorageService from '@infrastructure/local-storage-service';
import { getRecordNumberById } from '@application/features/history/historyThunk';
import { VisserModule } from '@application/common/enums/visser-module';
const App = () => {
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(selectIsLoading);
    const location = useLocation();
    useEffect(() => {
        moment.locale(i18n.language);
    }, []);
    useEffect(() => {
        const onStorageChange = (event) => {
            if (event.key === 'AUTH_TOKEN' && event.newValue === null)
                dispatch(logout());
        };
        window.addEventListener('storage', onStorageChange);
        return () => {
            window.removeEventListener('storage', onStorageChange);
        };
    }, [dispatch]);
    useEffect(() => {
        return () => {
            resetStateByPathName(location.pathname);
        };
    }, [location.pathname]);
    function getModuleName(tab) {
        switch (tab) {
            case 'WorkordersTabs':
                return VisserModule.Werkorder;
            case 'DebtorTabs':
                return VisserModule.Klanten;
            case 'CreditureTabs':
                return VisserModule.Leveranciers;
            case 'ArticleTabs':
                return VisserModule.Artikelen;
            case 'QuotationTabs':
                return VisserModule.Offertes;
            case 'InvoiceTabs':
                return VisserModule.Facturen;
            case 'OrderTabs':
                return VisserModule.Bestellingen;
            case 'PurchaseInvoicesTabs':
                return VisserModule.Inkoopfacturen;
            case 'DocumentationTabs':
                return VisserModule.Documnentatie;
            default:
                return VisserModule.Beheer;
        }
    }
    useEffect(() => {
        try {
            const currentURL = window.location.href;
            const parts = currentURL.split('/admin/');
            if (!LocalStorageService.getAccessToken() || parts.length <= 1 || !parts[1].includes('/')) {
                return;
            }
            const lastURLHistory = LocalStorageService.getURLHistory();
            const lastHistoryElement = lastURLHistory[lastURLHistory.length - 1];
            const url = parts[1].split('/');
            const tab = url[0];
            const id = parseInt(url[1]);
            if (isNaN(id)) {
                return;
            }
            const moduleId = getModuleName(tab);
            if (moduleId === VisserModule.Beheer) {
                return;
            }
            const getRecordNumberByIdrequest = { id, moduleId };
            dispatch(getRecordNumberById(getRecordNumberByIdrequest))
                .unwrap()
                .then((res) => {
                try {
                    if (res && typeof lastHistoryElement === 'undefined') {
                        LocalStorageService.setURLHistory(parts[1], res);
                    }
                    else if (res && lastHistoryElement.url !== parts[1] + '::' + res) {
                        LocalStorageService.setURLHistory(parts[1], res);
                    }
                }
                catch (error) { }
            })
                .catch((error) => { });
        }
        catch (error) { }
    }, [location]);
    return (_jsx(_Fragment, { children: _jsx("div", { style: { backgroundColor: '#F2F3F4', width: '100%' }, children: _jsxs(Container, { style: { maxWidth: 2560, backgroundColor: 'white', padding: 0 }, children: [_jsx(ToastContainer, { position: 'top-right', autoClose: 5000, newestOnTop: true, pauseOnHover: true, theme: 'colored' }), isLoading && _jsx(Loading, { isLoading: isLoading }), _jsx("div", { children: _jsx(AppRoutes, {}) })] }) }) }));
};
export default App;
